class MapboxTileSetStorage {
  async loadAllTiles(serviceObject, sourceId, map) {
    if (!serviceObject || !sourceId || !map) {
      throw new Error('Map instance, sourceId and storageKey are required');
    }

    const waitForSource = () => {
      return new Promise((resolve) => {
        const source = map.getSource(sourceId);
        if (source) {
          resolve();
        } else {
          const onSourceData = (e) => {
            if (e.sourceId === sourceId && map.getSource(sourceId)) {
              map.off('sourcedata', onSourceData);
              resolve();
            }
          };
          map.on('sourcedata', onSourceData);
        }
      });
    };

    const delay = (ms) => new Promise((res) => setTimeout(res, ms));

    if (map.getZoom() < serviceObject.getConfig('MIN_ZOOM')) {
      map.setMinZoom(serviceObject.getConfig('MIN_ZOOM'));
      await delay(1000);
    }

    await waitForSource();

    // Wait for all tiles to be loaded (map idle)
    await new Promise((resolve) => {
      if (map.loaded()) resolve();
      else map.on('idle', () => resolve());
    });
  }
}

export default new MapboxTileSetStorage();
